var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 260,
    viewBox: "0 0 199 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 198,
    height: 259,
    rx: 4.5,
    fill: "white",
    stroke: "#333333"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 39.5,
    x2: 169,
    y2: 39.5,
    stroke: "#333333"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 71.5,
    x2: 169,
    y2: 71.5,
    stroke: "#333333"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 103.5,
    x2: 169,
    y2: 103.5,
    stroke: "#333333"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 135.5,
    x2: 169,
    y2: 135.5,
    stroke: "#333333"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 167.5,
    x2: 169,
    y2: 167.5,
    stroke: "#333333"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 199.5,
    x2: 169,
    y2: 199.5,
    stroke: "#333333"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 231.5,
    x2: 169,
    y2: 231.5,
    stroke: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/privacy-policy.1206d0ab604d18e5b098c4522aaab147.svg";
export { ForwardRef as ReactComponent };